// 2. import createImageUrlBuilder from "@sanity/image-url";

// import { dataset, projectId } from "../env";

// // https://www.sanity.io/docs/image-url
// const builder = createImageUrlBuilder({ projectId, dataset });

// export const urlFor = (source) => {
//   return builder.image(source);
// };

// 1. import imageUrlBuilder from "@sanity/image-url";
// import { sanityClient } from "../client";

// const builder = imageUrlBuilder(sanityClient);

// export function urlFor(source) {
//   return builder.image(source);
// }

/*3*/

// sanity/lib/image.js
import createImageUrlBuilder from "@sanity/image-url";

// Import from environment variables
const projectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID;
const dataset = process.env.NEXT_PUBLIC_SANITY_DATASET;

const builder = createImageUrlBuilder({ projectId, dataset });

export const urlFor = (source) => builder.image(source);
